import { Link, useLocation } from 'react-router-dom';

import { DataTable } from '@/components/organisms/DataTable';
import { compareCageNames } from '@/utils/compareCageNames';

import { useLiceReportColumns } from './liceReportColumns';

import styles from './LiceReportLocationTable.module.scss';

export interface LocationCage {
    cageId: number;
    caligusElongatusAvg: number;
    caligusElongatusTotal: number;
    count: number;
    depthAvg: number;
    depthMax: number;
    depthMin: number;
    femaleAvg: number;
    femaleTotal: number;
    livingWeight: number;
    movingStageAvg: number;
    movingStageTotal: number;
    name: string;
    isIncluded?: boolean;
}

export interface LiceReportLocationTableProps {
    reportIndex: number;
    clientId: number;
    isChileanLice: boolean;
    locationId: number;
    cages: LocationCage[];
    averages: {
        count: number;
        depthAvg: number;
        depthMax: number;
        depthMin: number;
        femaleAvg: number;
        caligusElongatusAvg?: number;
        movingStageAvg: number;
        livingWeight: number;
        femaleTotal?: number;
        caligusElongatusTotal?: number;
        movingStageTotal?: number;
    };
    title: string;
    openDefault: boolean;
    onHandleCageSelected: (reportIndex: number, locationId: number, cage: LocationCage) => void;
    mode?: 'weekly' | 'daily';
}

export default function LiceReportLocationTable({
    reportIndex,
    clientId,
    isChileanLice,
    locationId,
    cages,
    averages,
    title,
    onHandleCageSelected,
    mode = 'weekly',
}: LiceReportLocationTableProps) {
    const location = useLocation();
    const isRegionLevel = !location.pathname.includes('/location/');
    const columns = useLiceReportColumns({
        reportIndex,
        clientId,
        isChileanLice,
        locationId,
        averages,
        mode,
        onHandleCageSelected,
    });
    const sortedCages = [...cages].sort((a, b) => compareCageNames(a.name, b.name));

    return (
        <div>
            <div className={styles.locationTitle}>
                {isRegionLevel ? (
                    // A link: it navigates, so it opens in a new tab like any other. The styles
                    // keep it looking like the heading text it sits in.
                    <Link
                        to={`/c/${clientId}/location/${locationId}/lice-report`}
                        className={styles.clickableTitle}>
                        {title}
                    </Link>
                ) : (
                    <span>{title}</span>
                )}
            </div>
            <DataTable
                data={sortedCages}
                columns={columns}
                getRowId={(cage) => String(cage.cageId)}
                enableSorting={false}
                responsive
                tableClassName={styles.locationTable}
            />
        </div>
    );
}
